import React from "react";

import { Box, Grid } from "@mui/material";
import { Typography } from "@mui/material";
import {
  imprintEmailAdress,
  linkedInProfileUrl,
  loginUrl,
  privacyPolicyRoute,
} from "common/constants/apiUrls";

const AGB = () => {
  return (
    <div className="ds">
      <Grid container className="digital-solution-page-b ">
        <Grid item sm={12} xs={12} className="text-center">
          <>
            <Typography variant="h1" className="heading ">
              Allgemeine Geschäftsbedingungen der
            </Typography>
            <Typography variant="h1" className="heading ">
              Volksbank Digital Solutions GmbH
            </Typography>
            <Typography variant="h1" className="heading ">
              Stand 08/2022
            </Typography>
          </>
        </Grid>
        <Grid item sm={6} xs={6} className="padded-container6 left-align padding-left-col">
          <Box component="div" className="AGB-content-container">
            <Typography variant="subtitle2" className="info-text ">
              A. Grundlagen/ Geltungsbereich
            </Typography>
            <br />
            <Typography variant="subtitle2" className="info-text ">
              § 1 Allgemeines
            </Typography>
            <ol>
              <li>
                Die nachstehenden Allgemeinen Geschäftsbedingungen (im Folgenden: „AGB“) gelten für
                sämtliche Vertragsverhältnisse zwischen der Volksbank Digital Solutions GmbH (im
                Folgenden „VDS“) und ihren Kunden (im Folgenden: „Kunde“) in der jeweiligen, zum
                Zeitpunkt des Vertragsschlusses aktuellen Fassung. Sie gelten auch dann, wenn bei
                Zusatzverträgen darauf nicht ausdrücklich hingewiesen wird.
              </li>
              <li>
                Die Allgemeinen Geschäftsbedingungen des Kunden erkennt VDS nicht an. Sie werden
                nicht Bestandteil der oben genannten Vertragsverhältnisse, es sei denn, VDS stimmt
                diesen ausdrücklich und schriftlich zu. Die hiesigen AGB gelten auch dann, wenn VDS
                Leistungen in Kenntnis entgegenstehender oder von den hiesigen AGB abweichender
                Bedingungen des Kunden vorbehaltlos erbringt.
              </li>
              <li>
                Diese Bedingungen gelten nur gegenüber Unternehmern, die bei Vertragsschluss in
                Ausübung ihrer gewerblichen Tätigkeit handeln sowie gegenüber juristischen Personen
                des öffentlichen Rechts und öffentlich-rechtlichen Sondervermögen.
              </li>
              <li>
                Für Rechtsbeziehungen zwischen VDS und dem Kunden ist allein der schriftlich
                geschlossene Vertrag maßgeblich, jeweils einschließlich der den Vertragsgegenstand
                betreffenden Regelungen dieser AGB. Die jeweiligen Softwareüberlassungsverträge, die
                etwaigen weiteren Einzelverträge jeweils nebst Anlagen sowie die zwischen den
                Parteien geschlossene Kooperationsvereinbarung genießen in der vorgenannten
                Reihenfolge bei Widersprüchen Vorrang vor diesen AGB. Die Einzelverträge
                einschließlich dieser AGB gibt alle Abreden zwischen den Vertragsparteien zum
                Vertragsgegenstand vollständig wieder. Mündliche Zusagen von VDS vor Abschluss des
                Vertrages sind rechtlich unverbindlich. Mündliche Abreden der Vertragsparteien
                werden durch den schriftlichen Vertrag ersetzt. Ergänzungen und Abänderungen der
                getroffenen Vereinbarungen einschließlich dieser AGB bedürfen zu ihrer Wirksamkeit
                der Schriftform. Dies gilt auch für die Aufhebung des Schriftformerfordernisses.
              </li>
            </ol>
            <br />
            <Typography variant="subtitle2" className="info-text ">
              B. Nutzungsüberlassung von Standardsoftware
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              § 1 Leistungsbeschreibung
            </Typography>
            <ol>
              <li>
                Soweit nicht anderweitig in den Softwareüberlassungsverträgen oder Einzelverträgen
                vereinbart, erwirbt der Kunde mit der Zahlung das nicht ausschließliche und nicht
                übertragbare Recht auf Nutzung der gelieferten Software (im Folgenden auch:
                „Programm(e)“) auf der im Vertrag genannten Anlage. Hat der Vertrag die
                Nutzungsüberlassung von Standard- Software zum Gegenstand, sind die jeweiligen
                Programme in der aktuellen, von VDS allgemein angebotenen Version
                Vertragsgegenstand. Das Urheberrecht und sämtliche sonstigen wirtschaftlichen
                Verwertungsrechte verbleiben bei VDS oder den Lizenzgebern von VDS.
              </li>
              <li>
                Bei Vereinbarung einer einmaligen Zahlung erwirbt der Kunde mit Zahlungseingang bei
                VDS ein zeitlich unbegrenztes Nutzungsrecht. Bei Vereinbarung monatlicher Gebühren
                erwirbt der Kunde das Nutzungsrecht für die Dauer des Vertrages (Miete).
              </li>
              <li>
                Die vereinbarte Beschaffenheit der Programme folgt, ohne dass VDS insoweit Garantien
                erklärt – bei Standard-Software aus der Programmbeschreibung. Die Programme
                ermöglichen in diesem Umfang regelmäßig und überwiegend Arbeitsergebnisse
                entsprechend den vorgegebenen Zielen. Nach dem Stand der Technik können jedoch
                Programme der vorliegenden komplexen Art nicht absolut fehlerfrei entwickelt werden.
                Entsprechend kann auch nicht an den Leistungsgegenstand die Erwartung vollständiger
                Fehlerfreiheit geknüpft werden. Erforderlich für den Einsatz der Programme ist eine
                gelegentliche Korrektur und/oder Anpassung der Programme an die konkreten
                Anforderungen der Praxis.
              </li>
              <li>
                Der Kunde erhält, soweit vereinbart, Programmdokumentationen, aus denen die
                Handhabung und der Leistungsumfang der Programme ersichtlich sind. VDS ist in der
                Gestaltung der Programmdokumentation frei.
              </li>
              <li>
                VDS (oder deren Lizenzgeber) überspielt die Programme auf die Hardware des Kunden
                per Datenfernübertragung oder stellt die Programme auf Datenträgern oder auf einem
                Server für die Datenfernübertragung zur Auslösung der Überspielung durch den Kunde
                zur Verfügung. Die Installation auf der Anlage des Kunden erfolgt durch den Kunde
                selbst. Leistungen an der Anlage werden von VDS nicht geschuldet. Beratung und
                Schulungen bietet VDS nach vorheriger Vereinbarung gesondert an.
              </li>
            </ol>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              § 2 Besondere Vertragspflichten; Beschränkungen des Nutzungsrechts
            </Typography>
            <ol>
              <li>
                Die Programme dürfen nur mit der im Vertrag angemeldeten und in der Datenbank
                registrierten Anzahl der vom Kunden abzurechnenden Verträge bzw. – soweit
                entsprechend vereinbart – der Anzahl von Usern (Lizenzumfang) und nur auf einem von
                VDS freigegebenen Betriebssystem genutzt werden. Die Übernahme der Programme auf ein
                anderes System oder die Nutzung durch eine größere Zahl von Usern bedarf der
                schriftlichen Genehmigung von VDS. VDS ist berechtigt, diese Genehmigung von der
                Zahlung einer weiteren Gebühr abhängig zu machen, falls durch die Änderung eine
                intensivere Nutzung der Programme möglich ist. Die Gebühr errechnet sich nach den
                jeweils gültigen allgemeinen Preislisten von VDS für Nutzungsrechte entsprechend der
                höheren Zahl von Usern bzw. für die Nutzung der Programme auf einem anderen System.
              </li>
              <li>
                Ohne schriftliche Zustimmung von VDS und soweit nicht anderweitig vereinbart, darf
                der Kunde keine Kopien der Software und/oder der zur Verfügung gestellten
                Dokumentationen für sich oder Dritte anfertigen. Der Kunde darf die Software oder
                Teile davon nicht außerhalb seines Geschäftsbetriebes für Zwecke Dritter einsetzen.
                Unbeschadet hiervon hat der Kunde das Recht, von den Programmen jeweils eine
                Sicherungskopie zu erstellen. Der Kunde muss auf die Sicherungskopie die Marke und
                den Urheber- rechtsvermerk von VDS anbringen. Nicht mehr benötigte Sicherungskopien
                sind zu löschen oder zu vernichten
              </li>
              <li>
                Änderungen und/oder Ergänzungen an den Programmen darf der Kunde nicht vornehmen.
                Meint der Kunde, eine Änderung und/oder Ergänzung sei erforderlich, um die
                bestimmungsgemäße Benutzung zu ermöglichen oder zu sichern, hat er dies VDS
                mitzuteilen. VDS wird die entsprechende Änderung selbst vornehmen oder aber einer
                Änderung durch den Kunde zustimmen, falls die Änderung erforderlich ist, um die
                bestimmungsgemäße Nutzung zu ermöglichen oder zu sichern. Dem Kunde obliegt im
                Zweifel der Nachweis über die ordnungs- und vertragsgemäße Handhabung des
                Software-Systems.
              </li>
            </ol>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              § 3 Weitere Bedingungen
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              Weiter gelten die gemeinsamen Bedingungen für alle Verträge nach Abschnitt E. und –
              sofern monatliche Gebühren (Miete) vereinbart wurden – die gemeinsamen Bedingungen für
              Mietverträge nach Abschnitt C.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              C. Bedingungen für Mietverträge
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              § 1 Vertragsdauer, ordentliches Kündigungsrecht
            </Typography>
            <ol>
              <li>Mietverträge beginnen mit der Bereitstellung der Programme.</li>
              <li>
                Soweit nicht anderweitig im Softwareüberlassungsvertrag oder den Einzelverträgen
                vereinbart, laufen die Verträge bis zum Ende des auf den Vertragsabschluss folgenden
                Jahres und verlängern sich um jeweils ein Jahr, wenn sie nicht mit einer Frist von
                drei M o n a t e n vor Ablauf der ursprünglichen bzw. der jeweils verlängerten
                Vertragsfrist gekündigt werden, sofern keine längere feste Laufzeit individuell
                vereinbart wird. Eine in dem Vertrag bestimmte Mindestlaufzeit errechnet sich ab
                Vertragsschluss. Soll der Vertrag mit Ablauf der Mindestvertragszeit enden, muss er
                zu diesem Zeitpunkt mit einer Frist von 3 Monaten schriftlich gekündigt werden.
                Geschieht dies nicht, verlängert er sich bis zum Jahresende und verlängert sich
                jeweils wieder um ein Kalenderjahr, wenn er nicht zum jeweils möglichen Endzeitpunkt
                mit einer Frist von 3 Monaten schriftlich gekündigt wird.
              </li>
            </ol>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              § 2 Kündigung aus wichtigem Grund durch VDS
            </Typography>
            <ol>
              <li>
                VDS kann Mietverträge fristlos kündigen, wenn der Kunde die Software vertragswidrig
                nutzt, sie insbesondere ungenehmigt Dritten überlässt, oder Änderungen an dem System
                ohne vorhergehende schriftliche Zustimmung von VDS vornimmt. Das Gleiche gilt für
                sonstige schwerwiegende Vertragsverletzungen, insbesondere wenn sich der Kunde über
                zwei aufeinander folgende Termine mit der Entrichtung der laufenden Gebühren oder
                eines nicht unerheblichen Teils – mindestens in Höhe einer vollen Monatsgebühr – in
                Verzug befindet.
              </li>
            </ol>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              § 3 Gebührenänderung, außerordentliche Kündigung
            </Typography>
            <ol>
              <li>
                VDS hat das Recht, seine allgemeinen Gebühren und Mieten den Bedingungen des
                Wettbewerbs und betriebswirtschaftlichen Erfordernissen anzupassen. Die Änderungen
                sind dann auch für die Vertragsparteien maßgebend. Wurde der Vertrag zu den
                allgemein geltenden Gebühren abgeschlossen, gelten die geänderten Gebühren
                unmittelbar, wurden die Gebühren besonders berechnet (etwa im Hinblick auf eine
                längere Vertragslaufzeit), gelten die neuen Gebühren entsprechend. Eine Änderung der
                laufenden Gebühren ist dem Kunde 2 Monate vor ihrer Wirksamkeit schriftlich
                mitzuteilen. Der Kunde ist berechtigt, mit einer Frist von 4 Wochen vor
                Inkrafttreten der Gebührenänderung den Vertrag zu kündigen, wenn die Gebühren oder
                Mieten um 5% oder mehr erhöht werden.
              </li>
            </ol>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              § 4 Weitere Bedingungen
            </Typography>
            <ol>
              <li>
                Es gelten weiter die gemeinsamen Bedingungen für alle Verträge nach Abschnitt E..
              </li>
            </ol>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              D. Beratungsverträge
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              § 1 Vertragsgrundlage
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              Die Beratung wird auf der Grundlage gesondert abzuschließender Einzelverträge
              durchgeführt. Hierzu stellt diese Vereinbarung einen Rahmenvertrag dar. In der
              Anforderung einer Beratung durch den Kunde liegt der Antrag zum Abschluss eines
              einzelnen Beratungsvertrages. VDS wird eine Beratung im Rahmen seiner personellen
              Möglichkeiten durchführen. VDS ist zum Abschluss der einzelnen Beratungsverträge nicht
              verpflichtet.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              § 2 Leistungsbeschreibung
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              Während der eigenen Geschäftszeit (vgl. jeweils gültige Preisliste) stellt VDS per
              E_Mail eine Beratungsstelle zur Verfügung. Die Beratung umfasst lediglich Fragen zur
              Funktion und Handhabung der Programme aus dem Programmpaket von VDS auf dem jeweils
              neuesten Stand, die von einem qualifizierten Kenner der Programme unmittelbar
              schriftlich per E-Mail beantwortet werden können.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              § 3 Weitere Bedingungen
            </Typography>
            <ol>
              <li>
                Alle in dem Vertrag genannten Preise sowie die Preise der jeweiligen Preislisten
                verstehen sich jeweils zzgl. der gesetzlichen Umsatzsteuer.
              </li>
              <li>
                Die einmaligen Vertragszahlungen (einmalige Nutzungsgebühr für Software, Gebühren
                für einzelne Dienstleistungen etc.) werden mit Erbringung der Leistung fällig und
                sind nach Erhalt der Rechnung sofort und ohne Abzug zu bezahlen. Vereinbarte
                Abschlagszahlungen sind mit Rechnungsstellung durch VDS sofort fällig.
              </li>
              <li>
                Die Fälligkeit und Zahlungsweise der Mieten bestimmt sich nach den im
                Softwareüberlassungsvertrag festgehaltenen Absprachen.
              </li>
              <li>
                Die Beratungsgebühren werden monatlich abgerechnet und sind sofort ohne Abzug fällig
              </li>
              <li>Kostenvoranschläge und sonstige Schätzpreise sind unverbindlich.</li>
              <li>
                Im Falle des Zahlungsverzugs des Kunden ist VDS berechtigt, für die noch
                ausstehenden Dienstleistungen eine Sicherheitsleistung in Höhe der vereinbarten
                Zahlung zu verlangen, die vollumfänglich vor der Ausführung der ausstehenden
                Dienstleistung zu erbringen ist
              </li>
              <li>
                Verändert sich der Preis von Gütern oder Leistungen, welche die Selbstkosten VDS
                betreffen (Kostenelemente), so verändert sich auch der Preis des Endprodukts, jedoch
                nur insoweit als sich die bei dem jeweiligen Kostelement eingetretene Preisänderung
                anteilig auf den Preis des Endprodukts auswirkt.
              </li>
            </ol>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              § 3 Weitere Bedingungen
            </Typography>
            <ol>
              <li>
                Alle in dem Vertrag genannten Preise sowie die Preise der jeweiligen Preislisten
                verstehen sich jeweils zzgl. der gesetzlichen Umsatzsteuer.
              </li>
              <li>
                Die einmaligen Vertragszahlungen (einmalige Nutzungsgebühr für Software, Gebühren
                für einzelne Dienstleistungen etc.) werden mit Erbringung der Leistung fällig und
                sind nach Erhalt der Rechnung sofort und ohne Abzug zu bezahlen. Vereinbarte
                Abschlagszahlungen sind mit Rechnungsstellung durch VDS sofort fällig.
              </li>
              <li>
                Die Fälligkeit und Zahlungsweise der Mieten bestimmt sich nach den im
                Softwareüberlassungsvertrag festgehaltenen Absprachen.
              </li>
              <li>
                Die Beratungsgebühren werden monatlich abgerechnet und sind sofort ohne Abzug fällig
              </li>
              <li>Kostenvoranschläge und sonstige Schätzpreise sind unverbindlich.</li>
              <li>
                Im Falle des Zahlungsverzugs des Kunden ist VDS berechtigt, für die noch
                ausstehenden Dienstleistungen eine Sicherheitsleistung in Höhe der vereinbarten
                Zahlung zu verlangen, die vollumfänglich vor der Ausführung der ausstehenden
                Dienstleistung zu erbringen ist
              </li>
              <li>
                Verändert sich der Preis von Gütern oder Leistungen, welche die Selbstkosten VDS
                betreffen (Kostenelemente), so verändert sich auch der Preis des Endprodukts, jedoch
                nur insoweit als sich die bei dem jeweiligen Kostelement eingetretene Preisänderung
                anteilig auf den Preis des Endprodukts auswirkt.
              </li>
            </ol>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              § 4 Pflichten des Kunden
            </Typography>
            <ol>
              <li>
                Der Kunde wird VDS bei der Erbringung der Beratungs- und Dienstleistungen in
                angemessenem Umfang unterstützen. Er wird ihr insbesondere die erforderlichen
                Informationen und Unterlagen vollständig und rechtzeitig zur Verfügung stellen und
                dafür Sorge tragen, dass VDS in ausreichender Anzahl geeignete Ansprechpartner mit
                dem erforderlichen Fachwissen zur Verfügung stehen.
              </li>
              <li>
                Der Kunde wird VDS bei Bedarf Zugang zu seinen Gebäuden und Räumlichkeiten gewähren,
                soweit dies zur Leistungserbringung erforderlich ist.
              </li>
              <li>Der Kunde hat für eine ordnungsgemäße Datensicherung zu sorgen.</li>
              <li>
                Verletzt der Kunde vorstehende geregelte Pflichten, verlängern sich etwaige seitens
                VDS einzuhaltende Leistungspflichten um den durch die Pflichtverletzung verursachten
                Zeitraum.
              </li>
              <li>
                Mit Vertragsende hat der Kunde unverzüglich und unaufgefordert sämtliche von VDS
                überlassene Unterlagen, Hilfsmittel, Materialien oder Gegenstände herauszugeben, die
                ihm zum Zwecke der Vertragsausführung bestimmungsgemäß nicht dauerhaft überlassen
                worden waren. Dies gilt auch für alle Kopien. Wahlweise kann VDS statt der
                Herausgabe die sichere Löschung oder Vernichtung verlangen.
              </li>
            </ol>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              § 5 Haftung für zu vertretende Pflichtverletzungen/Verzug
            </Typography>
            <ol>
              <li>
                Gerät VDS (oder deren Lizenzgeber) bei der Erfüllung einer Hauptleistungspflicht in
                Verzug, kann der Kunde von dem Vertrag zurücktreten, wenn er zuvor schriftlich eine
                erfolglos abgelaufene Frist von 4 Wochen zur Leistung oder Nacherfüllung gesetzt
                hat. Die Vertragslösung erfolgt durch Rücktritt, wenn VDS mit der Einräumung eines
                Software-Nutzungsrechtes oder der Erbringung einmaliger Dienstleistungen in Verzug
                geraten ist.
              </li>
              <li>
                Für Schäden aus Verletzung des Lebens, des Körpers oder der Gesundheit, die von
                Organen oder Erfüllungsgehilfen von VDS verursacht wurden, haftet VDS im
                gesetzlichen Rahmen; Gleiches gilt für Schäden, die auf Vorsatz oder grober
                Fahrlässigkeit beruhen.
              </li>
              <li>
                In Fällen leichter und einfacher Fahrlässigkeit von Organen oder Erfüllungsgehilfen
                von VDS übernimmt VDS die Haftung bei Verletzung von wesentlichen Vertragspflichten,
                deren Erfüllung die ordnungsgemäße Durchführung dieses Vertrages überhaupt erst
                ermöglicht und auf deren Einhaltung die Parteien regelmäßig vertrauen und vertrauen
                dürfen ("Kardinalpflicht"), jedoch begrenzt auf den bei Eintritt des
                Vertragsschlusses vernünftigerweise zu erwartenden Schadens.
              </li>
              <li>
                Hat VDS eine Pflichtverletzung nicht zu vertreten, bestehen keine Ansprüche auf
                Schadensersatz
              </li>
              <li>
                Unabhängig von den vorstehenden Bedingungen bleibt die Haftung nach dem
                Produkthaftungsgesetz für die von VDS selbst hergestellten Produkte bestehen.
              </li>
              <li>
                Vertragliche Schadensersatzansprüche des Kunden gegen VDS verjähren in einem Jahr ab
                Anspruchsentstehung, soweit nicht kürzere gesetzliche Verjährungsfristen bestehen.{" "}
              </li>
              <li>
                Ereignisse höherer Gewalt berechtigen VDS die Erfüllung ihrer Verpflichtungen für
                die Dauer der Behinderung und eine angemessene Anlaufzeit hinauszuschieben. Der
                höheren Gewalt sind Streiks, Aussperrungen und solche Umstände gleichzusetzen, die
                eine Leistungserfüllung unzumutbar erscheinen lassen oder unmöglich machen.
              </li>
            </ol>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              § 6 Rechte des Kunden bei Mängeln
            </Typography>
            <ol>
              <li>
                Für die Rechte des Kunden bei Sach- und Rechtsmängeln (einschließlich Falsch- und
                Minderlieferung sowie unsachgemäßer Montage/Installation oder mangelhafter
                Anleitungen) gelten die gesetzlichen Vorschriften, soweit nachfolgend nichts anderes
                bestimmt ist. In allen Fällen unberührt bleiben die gesetzlichen Sondervorschriften
                zum Aufwendungsersatz bei Endlieferung der neu hergestellten Ware an einen
                Verbraucher (Lieferantenregress gem. §§ 478, 445a, 445b bzw §§ 445c, 327 Abs. 5,
                327u BGB), sofern nicht, z.B. im Rahmen einer Qualitätssicherungsvereinbarung, ein
                gleichwertiger Ausgleich vereinbart wurde.
              </li>
              <li>
                Grundlage der Mängelhaftung von VDS ist vor allem die über die Beschaffenheit und
                die vorausgesetzte Verwendung der Produkte (einschließlich Zubehör und Anleitungen)
                getroffene Vereinbarung. Als Beschaffenheitsvereinbarung in diesem Sinne gelten alle
                Produktbeschreibungen und Herstellerangaben, insbesondere bei Standard-Software aus
                der Programmbeschreibung, die Gegenstand des einzelnen Vertrages sind oder von VDS
                (insbesondere in Katalogen oder auf unserer Internet-Homepage) zum Zeitpunkt des
                Vertragsschlusses öffentlich bekannt gemacht waren. Soweit die Beschaffenheit nicht
                vereinbart wurde, ist nach der gesetzlichen Regelung zu beurteilen, ob ein Mangel
                vorliegt oder nicht (§ 434 Abs. 3 BGB). Öffentliche Äußerungen von VDS oder in deren
                Auftrag insbes. in der Werbung oder auf dem Etikett der Ware gehen dabei Äußerungen
                sonstiger Dritter vor.
              </li>
              <li>
                Bei Produkten mit digitalen Elementen oder sonstigen digitalen Inhalten schuldet VDS
                eine Bereitstellung und ggf. eine Aktualisierung der digitalen Inhalte nur, soweit
                sich dies ausdrücklich aus einer individualvertraglichen Beschaffenheitsvereinbarung
                ergibt. Für öffentliche Äußerungen von Drittherstellern und sonstiger Dritter
                übernimmt VDS insoweit keine Haftung.
              </li>
              <li>
                Sollten die von VDS zur Nutzung überlassenen Software-Programme oder Teile davon zum
                Zeitpunkt der Übergabe bzw. Bereitstellung mit Mängeln im Sinne der §§ 434ff BGB
                oder sollten vermietete Programme später mit Mängeln im Sinne der §§ 536ff BGB
                behaftet sein, kann der Kunde im Rahmen der Gewährleistung zunächst nur
                Nachbesserung innerhalb angemessener Frist verlangen. Nach Wahl von VDS kann die
                Nachbesserung auch aus Lieferung eines Ersatzproduktes bestehen. Die Nachbesserung
                beinhaltet weder den Ausbau, die Entfernung oder Deinstallation der mangelhaften
                Sache noch den Einbau, die Anbringung oder die Installation einer mangelfreien
                Sache, wenn VDS ursprünglich nicht zu diesen Leistungen verpflichtet war; Ansprüche
                des Kunden auf Ersatz entsprechender Kosten ("Aus- und Einbaukosten") bleiben
                unberührt. Angemessen für die Nachbesserung VDS-eigener Produkte ist eine Frist von
                2 Wochen, für die Nachbesserung VDS-fremder Produkte und der Behebung von
                Funktionsstörungen einer Anlage eine Frist von 4 Wochen und für notwendige
                Änderungen von Software 3 Monate. Ein Nacherfüllungs/-besserungsanspruch ist
                ausgeschlossen, sofern der Kunde die nach § 377 HGB geschuldeten Untersuchungsund
                Rügeobliegenheiten nicht ordnungsgemäß erfüllt hat. Bei einer zum Einbau, zur
                Anbringung oder Installation bestimmten Ware gilt dies auch dann, wenn der Mangel
                infolge der Verletzung einer dieser Pflichten erst nach der entsprechenden
                Verarbeitung offenbar wurde; in diesem Fall bestehen insbesondere keine Ansprüche
                des Kunden auf Ersatz entsprechender Kosten ("Aus- und Einbaukosten"). Ebenfalls
                sind Nacherfüllungs-/ besserungsansprüche ausgeschlossen, wenn eine Nachbesserung
                mit einem unverhältnismäßigen Aufwand verbunden wäre. Hat der Kunde die gekauften
                Produkte nach der Lieferung an einen anderen Ort als seinen Wohnsitz oder seine
                gewerbliche Niederlassung verbracht, hat er, wenn das Verbringen der Produkte nicht
                ihrem bestimmungsgemäßen Gebrauch entspricht, die im Rahmen der
                Nacherfüllung/-besserungen hierdurch bedingten Mehraufwendungen zu tragen. <br />
                Im Rahmen der Nacherfüllung/-besserung ausgetauschte Teile gehen in das Eigentum von
                VDS über. Bei Softwaremängeln kann die Nacherfüllung/-besserung in der
                Übergabe/Installation einer neuen Programmversion bestehen, wenn hiermit keine
                Nutzungsbeschränkungen für den Kunden verbunden sind.
              </li>
              <li>
                Ist der Nacherfüllungsanspruch ausgeschlossen, verweigert VDS die
                Nacherfüllung/-besserung oder können die Mängel auch mit 2 Versuchen nicht innerhalb
                einer angemessenen Frist nach Anzeige des Mangels behoben werden, verbleiben dem
                Kunde die nachfolgenden weiteren Rechte:
                <br /> aa) Betrifft der Mangel zur Nutzung überlassene Software-Programme (bei
                Zahlung einer einmaligen Nutzungsgebühr), kann der Kunde das Vertragsentgelt nach
                Maßgabe des § 441 BGB mindern oder vom Vertrag zurücktreten. Ansprüche auf
                Schadensersatz bestehen allenfalls nach Maßgabe der weiteren Bedingungen dieser AGB.
                Unerhebliche Pflichtverletzungen können weder Ansprüche auf Schadensersatz statt
                Leistung begründen noch ein Rücktrittsrecht auslösen.
                <br /> bb) Betrifft der Mangel vermietete Programme, hat der Kunde das Recht zur
                fristlosen Vertragskündigung. Soweit und solange die Nutzung der Programme durch
                derartige Mängel eingeschränkt ist, kann der Kunde die laufende Gebühr nach Maßgabe
                des § 536 BGB mindern. Schadensersatzansprüche sind allenfalls nach Maßgabe dieser
                Bedingungen gegeben. Die Rechte des Kunden aus § 536a BGB werden ausgeschlossen,
                soweit VDS einen Mangel oder eine verzögerte Mangelbeseitigung nach Maßgabe dieser
                Geschäftsbedingungen nicht zu vertreten hat.
              </li>
              <li>
                Beratungs- und sonstige Dienstleistungen erbringt VDS nach bestem Wissen, nach
                Maßgabe des für das jeweilige Programm gegebenen Standards und mit dem Ziel, ein
                Arbeiten des Kunden mit der Hard- und Software nach Maßgabe der
                Leistungsbeschreibungen zu ermöglichen, ohne aber eine Garantie für den Erfolg der
                Dienstleistungen zu übernehmen.
              </li>
              <li>
                Eine Mängelrüge ist möglichst genau und umgehend nach der ersten Fehlfunktion bzw.
                Fehlermeldung schriftlich unter Angabe der zu der Fehlfunktion führenden
                Bedienungsschritte geltend zu machen. Eigene Versuche zur Fehlerbeseitigung führen
                regelmäßig zu größeren Schäden, für die VDS nicht haftet.
              </li>
              <li>
                Ansprüche des Kunden aus einer Software-Überlassung gegen Zahlung einer einmaligen
                Gebühr wegen eines Mangels des Vertragsgegenstandes verjähren mit Ablauf von 12
                Monaten nach Ablieferung/(Teil-)Abnahme des Vertragsgegenstandes.
              </li>
              <li>
                Erweist sich der gerügte Mangel als Folge eines Handhabungs-, Bedienungs- oder
                Eingabefehlers, entstand er durch vertragswidrige Nutzung mit einem nicht
                freigegebenen Betriebssystem oder mit sonstigen VDS- fremden Programmen, wurden
                Steuerungsmaßnahmen nicht beachtet oder hatte der Kunde eigene – fehlerhafte –
                Reparaturversuche unternommen, hat der Kunde VDS die durch die Mängelrüge
                verursachten Aufwendungen entsprechend der jeweils gültigen Preisliste für
                Dienstleistungen zu erstatten. Dies gilt entsprechend für die Fälle, in denen die
                Nachbesserungsarbeiten von VDS durch die vorstehend aufgeführten Umstände erschwert,
                behindert oder mehr als nur unwesentlich im Umfang erweitert wurden.
              </li>
            </ol>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              § 7 Unteraufträge
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              VDS ist berechtigt, zur Erfüllung seiner Vertragspflichten Unteraufträge an Dritte zu
              vergeben.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              § 8 Aufrechnung/Zurückbehaltungsrecht
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              Eine Aufrechnung gegen vertragliche Ansprüche von VDS ist nur zulässig mit
              unbestrittenen oder rechtskräftig festgestellten Forderungen des Kunden. Dies gilt
              entsprechend hinsichtlich eines Zurückbehaltungsrechts des Kunden.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              § 9 Datenschutz, Geheimhaltung und Sicherheit
            </Typography>
            <ol>
              <li>
                Sollten im Rahmen der Durchführung der Einzelverträge personenbezogene Daten erhoben
                werden, so stellen die Parteien sicher, dass dabei datenschutzrechtliche
                Bestimmungen beachtet werden.
              </li>
              <li>
                Sofern erforderlich, werden die Parteien gemäß den Vorgaben von Art. 28 DS-GVO eine
                Vereinbarung über die Auftragsverarbeitung schließen. In diesem Zusammenhang werden
                insbesondere alle Mitarbeiter der Parteien – vor allem Mitarbeiter und
                Verantwortliche, die Zugang zu personenbezogenen Daten haben – verpflichtet, den
                Anforderungen von Art. 28 Abs. 3 lit. c iVm Art. 32 Abs. 4 DS-GVO gerecht zu werden.
              </li>
              <li>
                Die Parteien sind verpflichtet, alle im Rahmen des Vertragsverhältnisses erlangten
                vertraulichen Informationen, Geschäfts- und Betriebsgeheimnisse vertraulich zu
                behandeln, insbesondere nicht an Dritte weiterzugeben oder anders als zu
                vertraglichen Zwecken zu verwerten. Hiervon unberührt bleibt die Erfüllung
                gesetzlicher Pflichten der Parteien.
              </li>
              <li>
                Vertrauliche Informationen sind Informationen, die ein verständiger Dritter als
                schützenswert ansehen würde oder die als vertraulich gekennzeichnet sind; dies
                können auch solche Informationen sein, die während einer mündlichen Präsentation
                oder Diskussion bekannt werden. Vertrauliche Informationen dürfen ausschließlich zum
                Zweck der Erfüllung der Verpflichtungen aus dem Vertrag eingesetzt werden. Die
                Verpflichtung zur Vertraulichkeit gilt nicht für Informationen, die den Parteien
                bereits rechtmäßig bekannt sind oder außerhalb des Vertrages ohne Verstoß gegen eine
                Vertraulichkeitsverpflichtung bekannt werden.
              </li>
              <li>
                Geschäftsgeheimnisse des Kunden iSv § 2 Nr. 1 GeschGehG darf VDS im
                Anwendungsbereich des § 1 GeschGehG nur gem. den Bestimmungen der § 3, § 4, § 5
                GeschGehG erlangen, nutzen bzw. offenlegen.
              </li>
            </ol>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              § 10 Force Majeur
            </Typography>
            <ol>
              <li>
                Soweit und solange ein Fall höherer Gewalt ("Force Majeure") vorliegt, sind die
                Parteien zeitweise von ihren Leistungspflichten befreit.
              </li>
              <li>
                Force Majeure ist ein betriebsfremdes, von außen durch elementare Naturkräfte oder
                durch Handlungen dritter Personen herbeigeführtes Ereignis, das nach menschlicher
                Einsicht und Erfahrung unvorhersehbar ist, mit wirtschaftlich erträglichen Mitteln
                auch durch die äußerste, nach der Sachlage vernünftigerweise zu erwartender Sorgfalt
                nicht verhütet oder unschädlich gemacht werden kann und auch nicht wegen seiner
                Häufigkeit in Kauf zu nehmen ist.
              </li>
              <li>
                Die Parteien können diesen Vertrag kündigen, wenn ein Force Majeure Ereignis länger
                als 2 Monate andauert und eine einvernehmliche Vertragsanpassung nicht erzielt
                werden kann.
              </li>
            </ol>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              § 11 Rechtswahl
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              Die Parteien vereinbaren hinsichtlich sämtlicher Rechtsbeziehungen aus diesem Vertrag
              die Anwendung des Rechts der Bundesrepublik Deutschland unter Ausschluss seiner
              kollisionsrechtlichen Bestimmungen und des Übereinkommens der Vereinten Nationen über
              Verträge über den internationalen Warenverkauf vom 11.4.1980 (UN-Kaufrecht).
            </Typography>
            <br />
            <Typography variant="subtitle2" className="info-text ">
              § 12 Salvatorische Klausel
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              Sollten einzelne Bestimmungen des Vertrages unwirksam sein, werden die übrigen
              Bestimmungen hiervon nicht berührt. Die Vertragspartner verpflichten sich, die
              unwirksamen Vorschriften schriftlich durch wirtschaftlich gleich- wertige zu ersetzen.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              § 13 Gerichtsstand
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              Ist der Kunde Kaufmann, ohne zu den in § 4 HGB genannten Gewerbetreibenden zu gehören,
              ist er eine juristische Person des öffentlichen Rechts oder öffentlich-rechtliches
              Sondervermögen, gilt als Gerichtsstand Karlsruhe..
            </Typography>
            <br></br>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default AGB;
